import React from 'react';

import { userIsLoggedIn } from '../Session/Session';
import AuthScreen from '../AuthScreen/AuthScreen';
import AuthAnimation from './Animation/AuthRedirect.json';

import Lottie from 'react-lottie';
import { ROOT_HOME } from '../../../routes/paths';

// @material-ui/core
import { Box, makeStyles, } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    page: {
        minHeight: '100vh',
        width: '100%',
        backgroundColor: theme.palette.colors.white,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    animatedLoader: {
        width: '361px !important',
    },
    img: {
        position: 'absolute',
        margin: 'auto',
        left: 0,
        right: 0,
        top: 90,
        textAlign: 'center',
    },
}));

const Auth = (props) => {
    const classes = useStyles();
    
    React.useEffect(() => {
        // Dependencia [] (no [props]): `props` cambia de identidad en cada render,
        // lo que re-disparaba history.push en bucle. Solo debe correr al montar.
        if (userIsLoggedIn()) {
            props.history.replace(ROOT_HOME);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box className={classes.page}>
            <Box mt={14} textAlign={'center'}>
                <Lottie options={{
                    loop: true,
                    autoplay: true,
                    animationData: AuthAnimation,
                    rendererSettings: {
                        className: classes.animatedLoader
                    }
                }} width={445} height={342}/>
            </Box>
            <AuthScreen {...props} />
        </Box>
    )
};

export default Auth;